import { CSS } from '../../../../theme/stitches.config';
import { SMPIcon, StyledIconVariants } from '../SMPIcon';

type SMPStartedIconProps = StyledIconVariants & {
  css?: CSS;
};

export const SMPStartedIcon = (props: SMPStartedIconProps): JSX.Element => {
  return (
    <SMPIcon {...props}>
      <svg fill='currentColor'>
        <path d='M7.125 13.625L4.16667 10.6667L5.375 9.45833L7.125 11.2083L10.625 7.70833L11.8333 8.91667L7.125 13.625ZM2.16667 16.6667C1.70833 16.6667 1.31597 16.5035 0.989583 16.1771C0.663194 15.8507 0.5 15.4583 0.5 15V3.33333C0.5 2.875 0.663194 2.48264 0.989583 2.15625C1.31597 1.82986 1.70833 1.66667 2.16667 1.66667H3V0H4.66667V1.66667H11.3333V0H13V1.66667H13.8333C14.2917 1.66667 14.684 1.82986 15.0104 2.15625C15.3368 2.48264 15.5 2.875 15.5 3.33333V15C15.5 15.4583 15.3368 15.8507 15.0104 16.1771C14.684 16.5035 14.2917 16.6667 13.8333 16.6667H2.16667ZM2.16667 15H13.8333V6.66667H2.16667V15ZM2.16667 5H13.8333V3.33333H2.16667V5Z' />
      </svg>
    </SMPIcon>
  );
};
